/**
 * @ngdoc Directive
 * @name vrm-nav-toggle
 * @example
 *
 * <ANY vrm-nav-toggle></ANY>
 */

(function(){
    'use strict';

    angular.module('vrm.components')
        .constant('vrmNavToggleEvent', {
            'toggle': 'vrmNavToggleEvent.toggle'
        })
        .directive('vrmNavToggle', vrmNavToggle);

    /* @ngInject */
    function vrmNavToggle($rootScope, vrmNavToggleEvent) {

        var definition = {
            restrict: 'A',
            link: link
        };

        return definition;

        function link($scope, $element, $attr) {
            $element.bind('click.vrmNavToggle', function(){
                $rootScope.$emit(vrmNavToggleEvent.toggle);
            });
        }
    }
})();
